import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Verificar si ya se ha dado el consentimiento
    const consent = localStorage.getItem('cookie-consent-accepted');
    if (consent === null) {
      // Mostrar el banner tras un pequeño retardo
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent-accepted', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent-accepted', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md bg-white/95 backdrop-blur-md border border-gray-100 rounded-2xl shadow-2xl p-6 z-50 transition-all duration-500 ease-in-out transform translate-y-0">
      <div className="space-y-4">
        <div>
          <h4 className="text-base font-bold text-gray-900">🍪 Uso de Cookies</h4>
          <p className="text-sm text-gray-600 mt-2 leading-relaxed">
            Utilizamos cookies para personalizar el contenido, analizar nuestro tráfico y garantizar el correcto funcionamiento del portal. Puedes revisar nuestra{' '}
            <Link to="/privacy" className="text-blue-600 hover:underline font-semibold">
              Política de Privacidad
            </Link>{' '}
            para más información.
          </p>
        </div>
        
        <div className="flex items-center justify-end space-x-3 pt-2">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-xs font-semibold text-gray-500 hover:text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
          >
            Rechazar
          </button>
          <button
            onClick={handleAccept}
            className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold rounded-lg shadow-md transition-colors"
          >
            Aceptar todo
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
